import { FunctionComponent, h } from 'preact';
import { useCallback, useEffect, useState } from 'preact/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup } from '@fortawesome/pro-regular-svg-icons/faLayerGroup';
import MapSettingsMenu from './map-settings-menu/map-settings-menu';
import { useTranslation } from '../../hooks/use-translation';
import { getIconVisibility } from '../../helpers/aria-helper';

interface Props {
	map: google.maps.Map;
}

const MapSettings: FunctionComponent<Props> = ({ map }) => {
	const { t } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);
	const [mapType, setMapType] = useState<google.maps.MapTypeId>(google.maps.MapTypeId.ROADMAP);
	const openMapSettingsMenu = useCallback(() => setIsOpen(true), []);
	const closeMapSettingsMenu = useCallback(() => setIsOpen(false), []);

	useEffect(() => {
		if (map && mapType !== map.getMapTypeId()) {
			map.setMapTypeId(mapType);
		}
	}, [mapType, map]);

	return (
		<div className="map-settings" data-testid="map-settings">
			<FontAwesomeIcon
				icon={faLayerGroup}
				onClick={openMapSettingsMenu}
				className="map-settings-layer-button"
				aria-hidden="false"
				role="button"
				aria-label={t('MAP_SETTINGS')}
				style={getIconVisibility(!isOpen)}
			/>
			{isOpen && (
				<MapSettingsMenu onClose={closeMapSettingsMenu} onChange={setMapType} currentMapType={mapType} />
			)}
		</div>
	);
};

export default MapSettings;
